import React from 'react';
import './style.css'
import LocationListItem from "./LocationListItem";
import {LocationItemLinkRoot} from "../styles";
import {useFeatureFlags} from "../../../hooks/routing/useFeatureFlags";


const LocationListItemLink = (props) => {
  const { location, to, listHover, setListHover, showVisibilityChip, isFavorite, showDistance } = props;
  const { supplierCapacitySchedule } = useFeatureFlags();
  const isAtCapacity = supplierCapacitySchedule && location?.hasAvailableCapacityToday === false;

  return (
    <div className={`ss-listing-location-list-item${isAtCapacity ? ' ss-listing-location-list-item--at-capacity' : ''}`}>
      <LocationItemLinkRoot to={`${to}`} target={'_blank'}>
        <LocationListItem
          location={location}
          listHover={listHover}
          setListHover={setListHover}
          showVisibilityChip={showVisibilityChip}
          isFavorite={isFavorite}
          isAtCapacity={isAtCapacity}
          showDistance={showDistance}
        />
      </LocationItemLinkRoot>
    </div>
  );
};

export default LocationListItemLink;
